import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

export default function General({
  isFormChanged,
  setIsFormChanged,
  userData,
  onSubmit,
}) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, dirtyFields },
    reset,
  } = useForm({
    defaultValues: {
      schoolName: '',
      address: '',
      phone: '',
      email: '',
    },
  });

  // userData kelganda formani yangilash
  useEffect(() => {
    if (userData) {
      reset({
        schoolName: userData.schoolName || '',
        address: userData.address || '',
        phone: userData.phone || '',
        email: userData.email || '',
      });
    }
  }, [userData, reset]);

  // Forma o'zgarganini kuzatish
  useEffect(() => {
    if (Object.keys(dirtyFields).length > 0 && !isFormChanged) {
      setIsFormChanged(true);
    }
  }, [dirtyFields, isFormChanged, setIsFormChanged]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-2">
      <div className="space-y-2">
        <Label htmlFor="schoolName">School Name</Label>
        <Input
          id="schoolName"
          placeholder="Enter school name"
          {...register('schoolName', { required: 'Required field' })}
        />
        {errors.schoolName && (
          <p className="text-sm text-red-500">{errors.schoolName.message}</p>
        )}
      </div>

      {/* Address */}
      <div className="space-y-2">
        <Label htmlFor="address">Address</Label>
        <Input
          id="address"
          placeholder="Enter address"
          {...register('address')}
        />
      </div>

      {/* Phone */}
      <div className="space-y-2">
        <Label htmlFor="phone">Phone</Label>
        <Input
          id="phone"
          placeholder="+998 XX XXX XX XX"
          {...register('phone')}
        />
      </div>

      {/* Email */}
      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          placeholder="example@mail.com"
          {...register('email')}
        />
      </div>

      <Button type="submit" disabled={true}>
        {isSubmitting ? 'Saving...' : 'Save Changes'}
      </Button>
    </form>
  );
}
